import React, { useEffect } from 'react';

import { Text } from 'react-konva';

let colorPressure = '#FF0000';

const TextFrequency = ({
  item,
  pressure,
  inverter,
  setColor,
  pressureMax,
  indexAlert,
  setIndexAlert,
}) => {
  useEffect(() => {
    const interval = setInterval(() => {
      if (
        parseFloat(pressure[item.number - 1]) >
        parseFloat(pressureMax[item.number - 1])
      ) {
        setIndexAlert([...indexAlert, item.number - 1]);
        setColor('#FFFF00');
        colorPressure = '#FFFF00';
        setTimeout(() => {
          if (colorPressure === '#FFFF00') {
            setColor('#FF0000');
          }
        }, 2000);
        setColor('#FFFF00');
      } else {
        setColor('transparent');
      }
    }, 500);
    return () => {
      clearInterval(interval);
    };
  }, [pressureMax[item.number - 1]]);

  return (
    <Text
      text={
        item.type === 'vf'
          ? inverter[item.number - 1] + ' Hz'
          : item.unit
          ? `${parseFloat(pressure[item.number - 1]).toFixed(2)} ${item.unit}`
          : parseFloat(pressure[item.number - 1]).toFixed(2)
      }
      x={item.type === 'pt' ? 11 : 30}
      y={20}
      fontSize={11}
      fill={'#003366'}
    />
  );
};

export default TextFrequency;
